import _ from 'lodash';

/*
  tools here must be independent of context ang business logic
 */

/**
 * @param obj object to check
 * @param props array of properties to check
 * @returns false if any of `props` is not defined on `obj`
 * TODO return type is not complete real, only the `props` are required, not the full object
 */
export function arePropsDefined<T extends Record<string, unknown>>(obj: T, props: (keyof T)[]): obj is Required<T> {
    return props.every(prop => !_.isNil(obj[prop]));
}

/**
 * @returns random value in uuid format, using math random
 */
export function uuid(): string {
    return `${1e7}${-1e3}${-4e3}${-8e3}${-1e11}`.replace(/1|0/g, () => (0 | (Math.random() * 16)).toString(16));
}

// -----------------------------------------------------
//       merge with undefined
//       TODO: test object is function
//       based on https://github.com/Istador/lodash-es-merge-undefined/blob/public/index.js
// -----------------------------------------------------

const UNDEFINED = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function merge(...args: [any, any]): any {
    // transform UNDEFINED to undefined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function toUndefined(v: any): any {
        return v === UNDEFINED ? undefined : Array.isArray(v) ? v.map(toUndefined) : _.isObject(v) ? _.mapValues(v, toUndefined) : v;
    }

    return _.mapValues(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _.mergeWith(...args, (a: any, b: any) => {
            if (b === undefined) {
                return UNDEFINED;
            }
            if (Array.isArray(a) || Array.isArray(b)) {
                return undefined;
            }
            if (typeof a === 'object' && typeof b === 'object') {
                return merge(a, b);
            }
            return undefined;
        }),
        toUndefined
    );
}

/**
 * based on
 * https://stackoverflow.com/a/57448862/2519073
 * @param str string to convert
 */
export function escapeHTML(str: string) {
    const replacer = (character: string) =>
        ({
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            "'": '&#39;',
            '"': '&quot;',
        })[character] as string;

    return str.replace(/[&<>'"]/g, replacer);
}

export function formatNumber(numberToFormat: number, maximumFractionDigits: number): string {
    const numberFormatter = Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 1,
        maximumFractionDigits,
        useGrouping: false,
    });
    return numberFormatter.format(numberToFormat);
}
